import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.73 2.545A5 5 0 0 1 17 7a1 1 0 0 1-2 0 3 3 0 1 0-4.763 2.427l.012.01a3 3 0 0 0 .573.323c.318.136.502.515.335.817l-2.442 4.394a2 2 0 1 1-1.748-.97l1.78-3.204a5 5 0 0 1 .983-8.252"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M21.229 18.668a4.999 4.999 0 0 0-5.734-7.436l-1.78-3.203A2 2 0 1 0 11.967 9l2.442 4.395c.167.302.587.346.869.148a3 3 0 0 1 1.996-.53 3 3 0 1 1-1.774 5.585 1 1 0 0 0-1 1.732 5 5 0 0 0 6.729-1.662"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2.575 18.328A5 5 0 0 0 11.9 17h3.369a2 2 0 1 0 0-2h-4.732c-.346 0-.588.345-.552.688a3 3 0 0 1-.534 2.043 3 3 0 1 1-3.95-4.33 1 1 0 1 0-1-1.731 5 5 0 0 0-1.925 6.658"
    }
  )
);
var SvgWebhookOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WebhookOutlined_default = SvgWebhookOutlined;

export { WebhookOutlined_default as default };
